import { useEffect, useState } from "react";
import PartnerGate from "./Gate";
import { EmptyState, StatusBadge } from "@/components/bits";
import api, { fmtDate } from "@/lib/api";

export default function Submissions() {
  const [submissions, setSubmissions] = useState([]);
  useEffect(() => {
    api.get("/partner/submissions").then(({ data }) => setSubmissions(data.submissions)).catch(() => {});
  }, []);

  return (
    <PartnerGate>
      {() => (
        <div data-testid="partner-submissions">
          {submissions.length === 0 ? (
            <EmptyState title="No submissions yet" description="Accept an opening and submit your first screened candidate." testId="submissions-empty" />
          ) : (
            <div className="bg-white border border-border/60 rounded-xl overflow-x-auto">
              <table className="w-full text-sm" data-testid="submissions-table">
                <thead className="bg-[#F8FAFC] border-b border-border/60 text-left text-xs text-muted-foreground">
                  <tr>
                    <th className="px-5 py-3.5 font-semibold">Candidate</th>
                    <th className="px-5 py-3.5 font-semibold">Job</th>
                    <th className="px-5 py-3.5 font-semibold">Recommendation</th>
                    <th className="px-5 py-3.5 font-semibold">Stage</th>
                    <th className="px-5 py-3.5 font-semibold">By</th>
                    <th className="px-5 py-3.5 font-semibold">Submitted</th>
                  </tr>
                </thead>
                <tbody>
                  {submissions.map((s) => (
                    <tr key={s.id} className="border-b border-border/40" data-testid={`submission-${s.id}`}>
                      <td className="px-5 py-4 font-semibold">{s.candidate_name}</td>
                      <td className="px-5 py-4">{s.job_title}</td>
                      <td className="px-5 py-4 text-xs capitalize">{(s.recommendation || "").replace(/_/g, " ")}</td>
                      <td className="px-5 py-4"><StatusBadge status={s.stage} /></td>
                      <td className="px-5 py-4 text-xs">{s.submitted_by_name || "Owner"}</td>
                      <td className="px-5 py-4 text-xs text-muted-foreground">{fmtDate(s.created_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </PartnerGate>
  );
}
